export default {
  getHlsSite(videoList, currentVideoId) {
    let video, hlsSite;
    for (let i = 0; i < videoList.length; i++) {
      if (videoList[i].videoId === currentVideoId) {
        video = videoList[i];
        if (videoList[i].videoType && videoList[i].videoType !== "0") {
          var transcodeData = videoList[i].transcodeData;
          if (transcodeData.format === "m3u8") {
            hlsSite = transcodeData.url;
            break;
          }
        } else {
          hlsSite = this.getRealMudoVodUrl(video);
        }
        break;
      }
    }
    return hlsSite;
  },
  getRealMudoVodUrl(video) {
    var hlsSite =
      video.transcodeData && video.transcodeData.url
        ? video.transcodeData.url
        : video.videoOrigin;
    if (video && video.videoOrigin) {
      var tempArray = video.videoOrigin.split(".");
      if (tempArray[tempArray.length - 1] === "m3u8") {
        hlsSite = video.videoOrigin;
      }
    }
    return hlsSite;
  }
};
